import { Box, Button, Popover, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import DeleteIcon from "../../Assets/Icons/DeleteIcon.svg";
import { ReactComponent as TrashIcon } from "../../Assets/Icons/TrashDeleteIcon.svg";
import { ColorScheme } from "../../Themes/ColorScheme";
import { Spinner } from "./Spinner";
import TooltipWrapper from "./TooltipWrapper";

export const ConfirmAction = ({
	buttonText,
	handleConfirmAction, // always required
	background,
	isLoading,
	hideTooltip,
	tooltipTitle,
	useTrashIcon,
	width
}) => {
	const { t } = useTranslation();
	const [anchorEl, setAnchorEl] = useState(null);

	const open = Boolean(anchorEl);
	const id = open ? "confirm-action-popover" : undefined;

	const handleClick = (event) => {
		event.stopPropagation();
		event.preventDefault();
		setAnchorEl(event.currentTarget);
	};

	const handleConfirm = (event) => {
		event.stopPropagation();
		event.preventDefault();
		handleConfirmAction();
		handleClose(event);
	};

	const handleClose = (event) => {
		event.stopPropagation();
		event.preventDefault();
		setAnchorEl(null);
	};

	return (
		<>
			<TooltipWrapper
				hide={hideTooltip}
				title={tooltipTitle}
				ignoreStringRestriction={true}
			>
				<Box
					onClick={(e) => handleClick(e)}
					sx={{ padding: "10px",
						backgroundColor: background ? ColorScheme.dangerPrimary : "transparent",
						width: width ? width : "auto",
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "space-between",
						borderRadius: "4px",
						cursor: "pointer",
						transition: "transform 0.2s ease-in-out",
						"&:hover": {
							transform: "scale(1.02)"
						},
						maxHeight: "20px"
					 }}
				>
					{!isLoading && buttonText && (
						<Typography sx={{fontSize: "14px", color: !background ? ColorScheme.red : ColorScheme.secondary}}>{buttonText}</Typography>)}
					{!isLoading && buttonText && (
						<div style={{width: "20px"}}/>)}
					{isLoading ? (
						<Spinner color={background ? ColorScheme.secondary : ColorScheme.red} />
					) : useTrashIcon ? (
						<TrashIcon
							stroke={background ? ColorScheme.secondary : ColorScheme.red}
							width={20}
							height={20}
						/>
					) : (
						<img
							style={{
								height: "20px"
							}}
							src={DeleteIcon}
						/>
					)}
				</Box>
			</TooltipWrapper>

			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={(event) => handleClose(event)}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "left"
				}}
			>
				<Typography sx={{ p: 2 }}>
					<Button onClick={(event) => handleConfirm(event)}>
						{t("buttons.confirm")}
					</Button>
					<Button onClick={(event) => handleClose(event)}>
						{t("buttons.cancel")}
					</Button>
				</Typography>
			</Popover>
		</>
	);
};
